export const uk = {
    'add-correction': 'Новая корректировка',
    'choose-all-retargeting-conditions': 'Все аудитории и условия ретаргетинга',
    'demography-title': 'Пол и возраст пользователя',
    'device-title': 'Тип устройств',
    'flat-mass-rate-control': 'Единая ставка для корректировки',
    'inventory-title': 'Тип инвентаря',
    'mass-rate-control': 'Ставка {control} %',
    'no-items-message': 'Корректировки ставок не заданы',
    'retargeting-edit-link': 'Настройка условий',
    'retargeting-title': 'Ретаргетинг и аудитории',
    'same-values-for-all-rate-control': 'Задать одинаковые значения для всех условий',
    'smart-banners-title': 'Настройка ставок для автоматически созданных смарт-объявлений',
    'traffic-jam-hint':
        'Корректировки работают по данным Яндекс.Карт. Для наружной рекламы учитывается дорожная ситуация перед рекламной поверхностью.',
    'traffic-jam-title': 'Корректировки по дорожной ситуации',
    'video-addition-title': 'Настройка ставок для объявлений с видеодополнением',
    'weather-title': 'Корректировки на погоду'
};
